import Header from "./components/Header/Header";
import HomePage from "./pages/HomePage/HomePage";
import Banking from "./pages/Banking/Banking";
import Footer from "./components/Footer/Footer";
import CaseStudies from "./pages/CaseStudies/CaseStudies";
import NewsAndEvents from "./pages/NewsAndEvents/NewsAndEvents";
import Insights from "./pages/Insights/Insights";
import PostDetail from "./pages/Insights/PostDetails";
import TagPage from "./pages/Insights/TagPage";
import Keywords from "./pages/Insights/KeyWords";
import SuccessStories from "./pages/SuccessStories/SuccessStories";
import ContractVehicles from "./pages/ContractVehicles/ContractVehicles";
import CompanyOverview from "./pages/CompanyOverview/CompanyOverview";
import OurCommunity from "./pages/CompanyOverview/OurCommunity";
import OurPartners from "./pages/CompanyOverview/OurPartners";
import Careers from "./pages/Careers/Careers";
import WeCare from "./pages/Careers/WeCare";
import RecruitmentFraudAwareness from "./pages/Careers/RecruitmentFraudAwareness";
import CurrentOpenings from "./pages/Careers/CurrentOpenings";
import JobListing from "./pages/Careers/JobListing";
import SolutionsServices from "./pages/SolutionsServices/SolutionsServices";
import ManagedCybersecurity from "./pages/ManagedCybersecurity/ManagedCybersecurity";
import EnterpriseAI from "./pages/EnterpriseAI/EnterpriseAI";
import DataAnalytics from "./pages/DataAnalytics/DataAnalytics";
import CloudServices from "./pages/CloudServices/CloudServices";
import OurLeaderShipTeam from "./pages/OurLeaderShip/OurLeaderShipTeam";
import ApplyJob from "./pages/Careers/ApplyJob";
import ContactUs from "./pages/ContactUs/ContactUs";
import PrivacyPolicy from "./pages/ContactUs/PrivacyPolicy";
import JobDesc from "./components/ApplyToJob/JobDesc";
import Videos from "./pages/Videospage/Videos";
import Faqs from "./pages/Careers/Faqs";
import SiteMap from "./pages/ContactUs/SiteMap";
import { jobsDesc } from "./StaticData/applytojob";
import Error from "./components/Error/Error";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ThankYouPage from "./pages/ThankYouPage/ThankYouPage";
import ScrollToTop from "./components/ScrollTop/ScrollTop";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";
import RajeshProfile from "./pages/OurLeaderShip/RajeshAdapa/Rajesh";
import AiNewsPage from "./pages/News/AiCompetenceNewsPage";
import AwsNewsPage from "./pages/News/AwsCompetenceNewsPage";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      {/* <Headers/> */}
      <Routes>
        <Route path="*" element={<Error />} />

        <Route path="/" element={<HomePage />} />

        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/sitemap" element={<SiteMap />} />

        {/* service pages */}
        <Route path="/gen-ai-banking" element={<Banking />} />
        <Route path="/next-gen-modernization" element={<SolutionsServices />} />
        <Route
          path="/managed-cybersecurity"
          element={<ManagedCybersecurity />}
        />
        <Route path="/enterprise-ai" element={<EnterpriseAI />} />
        <Route path="/data-analytics" element={<DataAnalytics />} />
        <Route path="/cloud-innovations" element={<CloudServices />} />

        {/* blog pages */}
        <Route path="/blog" element={<Insights />} />
        <Route path="/blog/:slug" element={<PostDetail />} />
        <Route path="/tag/:tag" element={<TagPage />} />
        <Route path="/keywords/:keyword" element={<Keywords />} />

        {/* Resource pages */}
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/partner-story" element={<SuccessStories />} />
        <Route path="/news-and-events" element={<NewsAndEvents />} />
        <Route path="/Videos" element={<Videos />} />

        {/* About us */}
        <Route path="/company-overview" element={<CompanyOverview />} />
        <Route path="/our-community" element={<OurCommunity />} />
        <Route path="/our-partners" element={<OurPartners />} />
        <Route path="/leadership-team" element={<OurLeaderShipTeam />} />

        {/* News and events */}
        <Route path="/news/idexcel-achives-aws-generative-ai-competency" element={<AiNewsPage />} />

        <Route path="/news/idexcel-achieves-aws-agentic-ai-competency" element={<AwsNewsPage />} />

        {/* Careers */}
        <Route path="/careers" element={<Careers />} />
        <Route
          path="/careers/we-care-about-our-employees"
          element={<WeCare />}
        />
        <Route
          path="/careers/recruitment-fraud-awareness"
          element={<RecruitmentFraudAwareness />}
        />
        <Route path="/careers/current-opening" element={<CurrentOpenings />} />
        <Route path="/careers/job-listings" element={<JobListing />} />
        <Route path="/careers/apply-to-job" element={<ApplyJob />} />
        <Route
          path="/careers/we-care-about-our-employees/faqs"
          element={<Faqs />}
        />

        {/* apply to job */}
        {jobsDesc.map((job) => (
          <Route key={job.link} path={job.link} element={<JobDesc />} />
        ))}
        {/* Careers */}
        <Route path="/careers" element={<Careers />} />
        <Route
          path="/careers/we-care-about-our-employees"
          element={<WeCare />}
        />
        <Route
          path="/careers/recruitment-fraud-awareness"
          element={<RecruitmentFraudAwareness />}
        />
        <Route path="/careers/current-opening" element={<CurrentOpenings />} />
        <Route path="/careers/job-listings" element={<JobListing />} />
        <Route path="/careers/apply-to-job" element={<ApplyJob />} />

        {/* apply to job */}
        {jobsDesc.map((job) => (
          <Route key={job.link} path={job.link} element={<JobDesc />} />
        ))}

        {/*Thankyou pages */}
        <Route path="/thank-you" element={<ThankYouPage />} />

        {/* footer */}

        <Route path="/contract-vehicles" element={<ContractVehicles />} />

        {/* redirections */}
        <Route
          path="/success-stories"
          element={<Navigate to="/partner-story" />}
        />
        <Route
          path="/our-leadership"
          element={<Navigate to="/leadership-team" />}
        />
        <Route
          path="/cloud-services"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/automation-and-ai/invisible-automation"
          element={<Navigate to="/enterprise-ai" />}
        />
        <Route
          path="/cloud-services/cloud-advisory/"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-services/aws-well-architected-framework-reviews"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-services/migration-services/"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-services/managed-services"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-services/microsoft-cloud-services"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-native-services"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-native-services/cloud-native-development/"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-native-services/devops-transformation/"
          element={<Navigate to="/cloud-innovations" />}
        />
        <Route
          path="/cloud-native-services/sre-and-aiops-solutions/"
          element={<Navigate to="/enterprise-ai" />}
        />
        <Route
          path="/automation-and-ai"
          element={<Navigate to="/enterprise-ai" />}
        />
        <Route
          path="/automation-and-ai/ai-in-the-cloud/"
          element={<Navigate to="/enterprise-ai" />}
        />
        <Route
          path="/automation-and-ai/augmented-intelligence-using-ai/"
          element={<Navigate to="/enterprise-ai" />}
        />
        <Route
          path="//data-platforms-and-intelligence"
          element={<Navigate to="/data-analytics" />}
        />
        <Route
          path="/data-platforms-and-intelligence/data-strategy-advisory/"
          element={<Navigate to="/data-analytics" />}
        />
        <Route
          path="/data-platforms-and-intelligence/data-platform-modernization/"
          element={<Navigate to="/data-analytics" />}
        />
        <Route
          path="/data-platforms-and-intelligence/data-visualization/"
          element={<Navigate to="/data-analytics" />}
        />
        <Route
          path="/cloud-native-services/open-source/"
          element={<Navigate to="/" />}
        />
        <Route
          path="/resources/case-studies/"
          element={<Navigate to="/case-studies" />}
        />
        <Route
          path="/resources/success-stories/"
          element={<Navigate to="/partner-story" />}
        />
        <Route
          path="/resources/news-events/"
          element={<Navigate to="/news-and-events" />}
        />
        <Route path="/resources/videos/" element={<Navigate to="/videos" />} />
        <Route path="/about-us" element={<Navigate to="/company-overview" />} />
        <Route
          path="/about-us/our-leadership"
          element={<Navigate to="/leadership-team" />}
        />
        <Route
          path="/privacy-statement"
          element={<Navigate to="/privacy-policy" />}
        />
        <Route
          path="/about-us/our-partners/"
          element={<Navigate to="/company-overview" />}
        />
        <Route path="/ai-banking" element={<Navigate to="/gen-ai-banking" />} />

        {/* rajesh_adapa */}
        <Route
          path="/about-us/our-leadership/rajesh-adapa"
          element={<RajeshProfile />}
        />
      </Routes>
      <ScrollToTopButton />
      <Footer />
    </Router>
  );
}

export default App;
